import { CSSProperties } from "react";

/**
 * Fresh palette for the new home UI.
 * NOTE: deliberately avoids the old purple footer gradient (#5f5a8c / #7c70af).
 */
export const HOME_THEME = {
  ink: "#0F172A",
  inkSoft: "#1E293B",
  primary: "#017E84",
  primaryDark: "#01575A",
  primarySoft: "#E6F4F4",
  accent: "#F59E0B",
  accentSoft: "#FEF3C7",
  surface: "#FFFFFF",
  surfaceAlt: "#F8FAFC",
  border: "#E2E8F0",
  muted: "#64748B",
  dark: "#0B1220",
  onDark: "#E2E8F0",
  onDarkMuted: "#94A3B8",
  heroHeading: "#1E3A8A",
};

export const sectionPadding = "38px 5%";

export const primaryBtn: CSSProperties = {
  backgroundColor: HOME_THEME.primary,
  color: "#FFFFFF",
  padding: "12px 26px",
  borderRadius: "10px",
  border: "none",
  fontWeight: 700,
  fontSize: "0.95rem",
  cursor: "pointer",
  boxShadow: "0 10px 24px rgba(1,126,132,0.28)",
};

export const secondaryBtn = (onDark = false): CSSProperties => ({
  backgroundColor: "transparent",
  color: onDark ? "#FFFFFF" : HOME_THEME.ink,
  padding: "12px 26px",
  borderRadius: "10px",
  border: `2px solid ${onDark ? "rgba(255,255,255,0.45)" : HOME_THEME.primary}`,
  fontWeight: 600,
  fontSize: "0.95rem",
  cursor: "pointer",
});

export const headingStyle: CSSProperties = {
  fontSize: "1.9rem",
  fontWeight: 800,
  // Deep indigo (not black) — matches the hero heading tone.
  color: HOME_THEME.heroHeading,
  margin: "0 0 0.35rem 0",
  lineHeight: 1.15,
};

export const subHeadingStyle: CSSProperties = {
  fontSize: "1rem",
  color: HOME_THEME.muted,
  maxWidth: "620px",
  margin: "0 auto",
  lineHeight: 1.5,
};

export const cardStyle: CSSProperties = {
  background: HOME_THEME.surface,
  border: `1px solid ${HOME_THEME.border}`,
  borderRadius: "16px",
  padding: "18px",
};
